const PrivacyEthicsSection = () => {
  const features = [
    {
      id: 1,
      title: 'Transparent AI',
      description: 'Fair, explainable, and unbiased insights.'
    },
    {
      id: 2,
      title: 'Privacy-first & HIPAA-compliant',
      description: 'Your data is protected at every step.'
    },
    {
      id: 3,
      title: 'Encrypted Communication',
      description: 'Secure therapy and consultation sessions.'
    }
  ];

  return (
    <section className="py-10 md:py-14 lg:py-18">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="  font-bold text-gray-900 mb-3 md:mb-4">
            <span className="">Privacy, Ethics & </span><span className="secondary-text">Trust in AI</span>
          </h2>
          <p className="    max-w-3xl mx-auto px-4">
            Ensuring your sensitive health information is always protected.
          </p>
        </div>

        {/* Main Container with Background Image */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl min-h-[230px] md:min-h-[280px] lg:min-h-[330px]">
          {/* Background Image Layer */}
          <div 
            className="absolute inset-0 w-full h-full"
            style={{
              backgroundImage: `url('/assets/platformBehavioral/5section.svg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          />

          {/* Blue Overlay Box */}
          <div className="relative mx-4 my-8 md:mx-8 md:my-12 lg:mx-12 lg:my-16">
            <div className="primary-bg rounded-2xl shadow-xl">
              <div className="px-4 py-8 md:px-8 md:py-10 lg:px-12 lg:py-12">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 lg:gap-12">
                  {features.map((feature, index) => (
                    <div
                      key={feature.id}
                      className="text-center group relative"
                      style={{ animationDelay: `${index * 0.15}s` }}
                    >
                      {/* Vertical Divider */}
                      {index < features.length - 1 && (
                        <div className="hidden md:block absolute -right-5 lg:-right-6 top-1/2 -translate-y-1/2 h-24 lg:h-28 w-px bg-white opacity-25" />
                      )}
                      
                      <div className="relative px-2">
                        <h3 className="text-white    font-semibold mb-2 md:mb-3 transition-transform duration-300 group-hover:scale-105 whitespace-nowrap">
                          {feature.title}
                        </h3>
                        <p className="text-white text-xs md: lg: opacity-90 leading-relaxed">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .group {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        @media (prefers-reduced-motion: reduce) {
          .group {
            animation: none;
            // opacity: 1;
          }
        }
      `}</style>
    </section>
  );
};

export default PrivacyEthicsSection;